import BackgroundLayer from "@/components/BackgroundLayer";
import { CHOICE_SHORT, THRESHOLD_LABELS, classifySequence, getBlock2Copy, getAdvisorPiece } from "@/data/exhaleData";
import { ListenButton } from "@/components/AudioControls";

export default function TheExhale({ sessionData, onNext, stageIndex }) {
  const thresholdDisplay = THRESHOLD_LABELS[sessionData.threshold] || sessionData.threshold;
  const result = classifySequence(sessionData.e1, sessionData.e2, sessionData.e3);
  const block2 = getBlock2Copy(result.type);
  const advisorPiece = getAdvisorPiece(result.type);
  const block2Paragraphs = block2.split("\n\n");

  return (
    <div className="page-wrapper" data-testid="exhale-page">
      <BackgroundLayer image="/images/page7_bg.jpg" />
      <div className="content-layer" style={{ minHeight: "100vh", minHeight: "100dvh" }}>
        <div className="page-content" style={{ paddingTop: 60, paddingBottom: 80 }}>
          <div className="section-label animate-in" style={{ marginBottom: 12 }}>05: The Exhale</div>
          <div className="animate-in animate-in-d1" style={{ marginBottom: 20 }}>
            <ListenButton stageIndex={stageIndex} />
          </div>

          {/* Side by side recap */}
          <p className="animate-in animate-in-d1" style={{ color: "rgba(184,212,208,0.5)", fontSize: "0.88rem", marginBottom: 20 }}>
            Your stated threshold: {thresholdDisplay}
          </p>

          <div className="side-by-side animate-in animate-in-d2">
            <div className="sbs-header">Your Path</div>
            <div className="sbs-header">Actual Market</div>
            <div className="sbs-row">
              <div className="sbs-cell user-choice">
                <div style={{ fontSize: "0.68rem", letterSpacing: "0.12em", color: "rgba(184,212,208,0.35)", marginBottom: 4 }}>September 2008</div>
                {CHOICE_SHORT[sessionData.e1] || "—"}
              </div>
              <div className="sbs-cell market">S&P: -4.7%</div>
            </div>
            <div className="sbs-row">
              <div className="sbs-cell user-choice">
                <div style={{ fontSize: "0.68rem", letterSpacing: "0.12em", color: "rgba(184,212,208,0.35)", marginBottom: 4 }}>October 2008</div>
                {CHOICE_SHORT[sessionData.e2] || "—"}
              </div>
              <div className="sbs-cell market">S&P: -16.9%</div>
            </div>
            <div className="sbs-row">
              <div className="sbs-cell user-choice">
                <div style={{ fontSize: "0.68rem", letterSpacing: "0.12em", color: "rgba(184,212,208,0.35)", marginBottom: 4 }}>March 2009</div>
                {CHOICE_SHORT[sessionData.e3] || "—"}
              </div>
              <div className="sbs-cell market">S&P: -56.8% total</div>
            </div>
          </div>

          <p className="recovery-line animate-in animate-in-d3">
            Your portfolio fully recovery: 2013, and +200% by 2020
          </p>

          {/* Exhale intro — moved closer to table, removed conversational lines */}
          <p className="body-text animate-in animate-in-d3" style={{ marginTop: 20, marginBottom: 8 }}>
            Here is "an exhale" of your sequence from the scenario.
          </p>

          {/* Block 1 — User's sequence description */}
          <div className="exhale-block animate-in animate-in-d4" data-testid="exhale-block1">
            {result.block1}
          </div>

          {/* Block 2 type-specific audio — between Block 1 and Block 2 */}
          <div className="animate-in animate-in-d5" style={{ marginTop: 16, marginBottom: 16 }}>
            <ListenButton audioKey={`block2_${result.type}`} />
          </div>

          {/* Block 2 — Main content */}
          <div className="exhale-block animate-in animate-in-d6" data-testid="exhale-block2">
            {block2Paragraphs.map((para, i) => (
              <p key={i} style={{ marginBottom: i < block2Paragraphs.length - 1 ? 36 : 0 }}>
                {para}
              </p>
            ))}
          </div>

          {/* Advisor piece — separate box for Types 4 & 5 */}
          {advisorPiece && (
            <div className="exhale-block animate-in animate-in-d7" data-testid="exhale-advisor-block" style={{ borderLeft: "2px solid rgba(184,212,208,0.15)" }}>
              {advisorPiece.split("\n\n").map((para, i) => (
                <p key={i} style={{ marginBottom: i < advisorPiece.split("\n\n").length - 1 ? 36 : 0 }}>
                  {para}
                </p>
              ))}
            </div>
          )}

          <p className="muted-caption animate-in animate-in-d8" style={{ marginTop: 20 }}>
            Nothing is recorded on our side.
          </p>

          {/* Continue */}
          <div style={{ marginTop: 40 }} className="animate-in animate-in-d8">
            <button className="cta-pill" onClick={onNext} data-testid="continue-btn">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
